<template>
  <div class="page-index">
    <div class="option1">
      <div class="shop-logo">
        <img src="../../assets/images/icon.png" alt />
      </div>
      <div class="shop-title">
        <img src="../../assets/images/title.png" alt />
        <div class="title-itme">
          <span>创建自营外卖小程序</span>
        </div>
      </div>
      <van-button @click="goSetShopPage" class="van-button1" round>一键开通</van-button>
      <div class="shop-ad">把顾客，留在自己平台</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goSetShopPage() {
      this.$router.push({
        name: 'catering-register'
      })
    },
  },
}
</script>

<style lang="css" scoped>
.page-index {
  height: 100%;
  background: url('../../assets/images/index-banner.png') no-repeat center;
  background-size: auto 100%;
}
.option1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: 65px;
  box-sizing: border-box;
  background: linear-gradient(
    135deg,
    rgba(17, 62, 195, 1),
    rgba(15, 67, 177, 0.4)
  );
}
.shop-logo > img {
  width: 135px;
  height: 42px;
  margin-top: 20px;
}
.shop-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}
.shop-title > img {
  width: 289px;
  height: 33px;
}
.title-itme {
  margin-top: 10px;
}
.title-itme span {
  font-size: 24px;
  color: #fff;
}
.van-button1 {
  width: 160px;
  height: 49px;
  margin-top: 132.5px;
  color: #1258cb;
  font-weight: 700;
  font-size: 16px;
}
.shop-ad {
  margin-top: 20px;
  font-size: 18px;
  color: #fff;
}
</style>